import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'app/modules/shared/services/api.service';
import { AlertMessage } from 'app/shared/utils/alertMessage';
import { CryptoService } from 'app/shared/utils/crypto.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-members-tab-stars-user-details-analtics',
  templateUrl: './members-tab-stars-user-details-analtics.component.html',
  styleUrls: ['./members-tab-stars-user-details-analtics.component.scss']
})
export class MembersTabStarsUserDetailsAnalticsComponent implements OnInit {
  @Input() userName: string;
  @Input() selectedApp: any;
  userData: any = {
    userDetails: undefined,
    //teams: undefined,
    //practiceSets: undefined,
    //lessons: undefined,
    userName: undefined,
  };

  constructor(
      public api: ApiService,
      private crypto: CryptoService
    ) {
      
    }

  ngOnInit() {
    //console.log(JSON.stringify(this.userData));
    this.getUserDetails(this.userName);
  }

  async getUserDetails(name) {
    this.userData.userDetails = undefined;
    let nameStr = this.crypto.isProbablyEncrypted(name) ? name : await this.crypto.encryptData(name);
    this.api.get("/analytics/UserAnalyticsDetails/" + nameStr + (this.selectedApp.id ? "?gameId=" + this.selectedApp.id : "")).subscribe(
      async (success) => {
        if (success && success[0]) {
          this.userData.userDetails = success[0];

          if (this.userData.userDetails.email) {
            this.userData.userDetails.emailDec = await this.crypto.decryptData(this.userData.userDetails.email);
          }

          if (this.userData.userDetails.username) {
            this.userData.userDetails.usernameDec = 
            this.crypto.isProbablyEncrypted(this.userData.userDetails.username) ? await this.crypto.decryptData(this.userData.userDetails.username)
              : this.userData.userDetails.username;
          }

          this.userData.userDetails.nameIcon = success[0].userRole == "Guest" ? success[0].username.substring(0, 2) : success[0].firstName.split("")[0] + success[0].lastName.split("")[0];
        } else {
          this.userData.userDetailsMessage = "No data found";
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  getError(err) {
      if (err.status == 401) {
        this.api.notifyInfo(AlertMessage.exitingCurrentSession);
        this.api.logmeout();
      }
    }

}
